export default __webpack_public_path__ + "static/media/IMG_1470.ace8797f.jpg";